import { Table, Text } from '@nimbus-ds/components';
import { useTranslationCatalog } from 'domains/Catalog/hooks';

function TransferHeaderCells() {
  const t = useTranslationCatalog();

  return (
    <>
      <Table.Cell width="32%">
        <Text fontWeight="bold">
          {t('transfers.new.table.headers.products')}
        </Text>
      </Table.Cell>
      <Table.Cell width="30%">
        <Text fontWeight="bold">
          {t('transfers.new.table.headers.variations')}
        </Text>
      </Table.Cell>
      <Table.Cell width="15%">
        <Text fontWeight="bold">{t('transfers.new.table.headers.stock')}</Text>
      </Table.Cell>
      <Table.Cell width="6.5rem">
        <Text fontWeight="bold">
          {t('transfers.new.table.headers.transfer')}
        </Text>
      </Table.Cell>
      <Table.Cell width="5rem">
        <Text fontWeight="bold">
          {t('transfers.new.table.headers.exclude')}
        </Text>
      </Table.Cell>
    </>
  );
}

export default TransferHeaderCells;
